import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import BaseServiceApi from 'BaseServiceApi';
import UserInfoUtil from 'UserInfoUtil';
import SwingSize from "../../../../../RayCustomControls/SwingSize/SwingSize.jsx";
import { RiTabTitle } from "../../../../../Constants/RiSubCategoryType.js";
import GraphType from "../../../../../Constants/GraphType.js";
import RiPanelFutureEvents from "./RiPanelFutureEvents.jsx";
import { RiPanelConstants } from "../../../../../Constants/RiPanelConstants.js";
import RiPanelAiStatistics from "./RiPanelAiStatistics.jsx";
import RiSubCategoryType from "../../../../../Constants/RiSubCategoryType.js";
import ScrollBar from "ScrollBar";
import SmartViewType from "../../../../../Constants/SmartViewType.js";

const { ActionTypes } = RiPanelConstants;
const EntitlementType = BaseServiceApi.rayData["EntitlementType"];

const RiPanelAiInfo = ({ isZigzagVisible, isTrackPriceAIVisible, isLineChart, isIndex, isShowPercentileChange, majorPeriodicity, isTrackPriceAIApplicable, updateZZIndicatorSettings, disableDefaultPriceLabels, updateTrackPriceAISettings, handlePercentileChangeToggle, isFutureEventOn, isFutureEventAIApplicable }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(RiTabTitle.HistoricalNews)

  const isAiTrackPriceNewsEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.AI_TRACK_PRICE_NEWS_Entitlement);
  const isFutureEventEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.AI_FUTURE_EVENTS_Entitlement);
  const isZigzagAIEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.ZIGZAG_AI_INDICATOR_Entitlement);

  const isShowZigZagStatistics = isZigzagVisible && (majorPeriodicity === GraphType.Daily || majorPeriodicity === GraphType.Weekly || majorPeriodicity === GraphType.Monthly);

  const handleToggle = () => {

    updateZZIndicatorSettings(isZigzagVisible);

    // As per requirement - Disable HighLow and %chg options in Price context menu and 
    // hide the price and %chg values from priceChart view when zigzag is turned on. And display zigzag price labels.
    if ((majorPeriodicity === GraphType.Daily || majorPeriodicity === GraphType.Weekly || majorPeriodicity === GraphType.Monthly) && !isLineChart) {
      disableDefaultPriceLabels(isZigzagVisible);
    }

  };

  const handleTrackPriceAIToggle = () => {
    updateTrackPriceAISettings(isTrackPriceAIVisible);
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleFutureEventToggle = () => {
    dispatch({
      type: ActionTypes.UPDATE_FUTURE_EVENT_VISIBILITY_SETTINGS,
      isVisible: !isFutureEventOn,
    });
  };

  return (
    <div className="zigzag-toggle-container">
      <div className="alertTabs">
        <ul>
          <li
            className={activeTab === RiTabTitle.HistoricalNews ? "active" : "inactive"}
            onClick={() => handleTabChange(RiTabTitle.HistoricalNews)}
          >
            <a>Historical News</a>
          </li>
          <li
            className={isFutureEventEntitled ? (activeTab === RiTabTitle.FutureEvents ? "active" : "inactive") : "disabled-tab"}
            onClick={() => isFutureEventEntitled ? handleTabChange(RiTabTitle.FutureEvents) : null}
          >
            <a>Future Events</a>
          </li>
        </ul>
      </div>
      <div className="ai-details">
      <div id="scrollRIPanelAiTab">
      {activeTab === RiTabTitle.HistoricalNews && (
        <>
          {isAiTrackPriceNewsEntitled && <div className={`toggle-section ${!isTrackPriceAIApplicable ? 'option-disabled' : ''}`}>

            <div className="on-off-switch">
              <label className="switch"
                onClick={isTrackPriceAIApplicable && handleTrackPriceAIToggle} // Disable click
              >
                <div
                  className={isTrackPriceAIVisible ? "toggle-switch active" : "toggle-switch"}
                  id="toggleSwitch"
                >
                  <div className="switch-circle"></div>
                  <span className="toggle-text off">OFF</span>
                  <span className="toggle-text on">ON</span>
                </div>
              </label>
            </div>
            <span className="title">
              Track Price News
            </span>
          </div>}
          {isZigzagAIEntitled && <div className="toggle-section">

            <div className="on-off-switch">
              <label className="switch" onClick={handleToggle}>
                <div
                  className={isZigzagVisible ? "toggle-switch active" : "toggle-switch"}
                  id="toggleSwitch"
                >
                  <div className="switch-circle"></div>
                  <span className="toggle-text off">OFF</span>
                  <span className="toggle-text on">ON</span>
                </div>
              </label>
            </div>
  
            <div className="swing-size">
              <span className="title">
                Zigzag Indicator
                <p>Click a segment for news and events from targeted period</p>
              </span>

              <span className="heading">Minimum Swing Size</span>
               <SwingSize tab={RiTabTitle.HistoricalNews} />
            </div>
          </div>}
          {isShowZigZagStatistics && <RiPanelAiStatistics/>}
          {isIndex && <div className="toggle-section">
            <div className="swing-size">
              <span className="title">
                % Chg and Duration Targets 
              </span>
            </div>
            <div className="on-off-switch">
              <label className="switch" onClick={()=> handlePercentileChangeToggle(!isShowPercentileChange)}>
                <div
                  className={isShowPercentileChange ? "toggle-switch active" : "toggle-switch"}
                  id="toggleSwitch"
                >
                  <div className="switch-circle"></div>
                  <span className="toggle-text off">OFF</span>
                  <span className="toggle-text on">ON</span>
                </div>
              </label>
            </div>
          </div>}
        </>
      )}
      {
        activeTab === RiTabTitle.FutureEvents && (
          <>
            <RiPanelFutureEvents
              handleToggle={handleFutureEventToggle}
              isFutureEventOn={isFutureEventOn}
              isFutureEventAIApplicable={isFutureEventAIApplicable}
            />
            <div className="toggle-section">
              <div className="swing-size" style={{ marginLeft: "20px", marginRight: "10px" }}>
                <span className="heading">GUTTER SIZE</span>
                <SwingSize tab={RiTabTitle.FutureEvents} disabled={!isFutureEventAIApplicable} />
              </div>
            </div>
          </>
        )
      }
      </div>
      <ScrollBar scrollId='scrollRIPanelAiTab' vScroll={true} />
      </div>
    </div>
  )
};

const mapStateToProps = ({ DatagraphReducers, aiNewsReducer, RelatedInfoPanelReducers }) => {

  const isZigzagVisible = RelatedInfoPanelReducers.RiPanelAI.aiSettings?.zigzagIndicator?.isVisible;
  const isTrackPriceAIVisible = RelatedInfoPanelReducers.RiPanelAI.isTrackPriceAIVisible;
  const isShowPercentileChange = RelatedInfoPanelReducers.RiPanelAI.isShowPercentileChange
  const { majorPeriodicity, SymTypeEnum, SymbolType } = DatagraphReducers.DataGraphReducer;
  const isIndex = SymbolType === SmartViewType.INDEX;
  const isLineChart = DatagraphReducers.PriceChartReducer.isLineChart;
  const { applicableInstrumentsTrackPriceAI, applicableInstrumentsFutureEventsAI } = aiNewsReducer
  const isTrackPriceAIApplicableForSymbol = applicableInstrumentsTrackPriceAI.includes(SymTypeEnum) ? true : false;
  const isTrackPriceAIApplicableForPeriodicity = majorPeriodicity === GraphType.Daily || majorPeriodicity === GraphType.Weekly || majorPeriodicity === GraphType.Monthly
  const isTrackPriceAIApplicable = isTrackPriceAIApplicableForSymbol && isTrackPriceAIApplicableForPeriodicity
  const isFutureEventAIApplicableForSymbol = applicableInstrumentsFutureEventsAI.includes(SymTypeEnum) ? true : false;
  const isFutureEventAIApplicableForPeriodicity = majorPeriodicity === GraphType.Daily || majorPeriodicity === GraphType.Weekly || majorPeriodicity === GraphType.Monthly
  const isFutureEventEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.AI_FUTURE_EVENTS_Entitlement);
  const isFutureEventAIApplicable = isFutureEventAIApplicableForSymbol && isFutureEventAIApplicableForPeriodicity && isFutureEventEntitled;
  const isFutureEventOn = RelatedInfoPanelReducers.RiPanelAI.aiSettings?.futureEvent.isVisible;
  return { isZigzagVisible, isTrackPriceAIVisible, isLineChart, majorPeriodicity, isTrackPriceAIApplicable, isIndex, isShowPercentileChange, isFutureEventOn, isFutureEventAIApplicable }
}

const mapDispatchToProps = (dispatch) => ({
  updateZZIndicatorSettings: (isZigzagVisible) => dispatch({
    type: ActionTypes.UPDATE_ZZ_INDICATOR_SETTINGS,
    isVisible: !isZigzagVisible,
  }),
  disableDefaultPriceLabels: (isZigzagVisible) => dispatch({
    type: ActionTypes.DISABLE_DEFAULT_PRICE_LABELS,
    isDisabled: !isZigzagVisible
  }),
  updateTrackPriceAISettings: (isTrackPriceAIVisible) => dispatch({
      type: ActionTypes.UPDATE_TRACK_PRICE_AI_SETTINGS,
      isVisible: !isTrackPriceAIVisible,
    }),
  handlePercentileChangeToggle: (isShowPercentileChange) => dispatch({
      type: ActionTypes.TOGGLE_PERCENTILE_CHANGE,
      isShowPercentileChange
    })
})

export default connect(mapStateToProps, mapDispatchToProps)(RiPanelAiInfo);
